module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Summer Essentials","subtitle":"Make the great day happen","linkLabel":"Shop collection"},"de":{"title":"Sommer Essentials","subtitle":"Die wichtigsten Stücke des Sommer Trends","linkLabel":"Jetzt bestellen"}}')
  delete Component.options._Ctor
}
